import { useTranslation } from "react-i18next";
import { Clock, Languages, MapPin } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { ContactForm } from "@/components/ContactForm";
import { ContactChannels } from "@/components/ContactChannels";
import { EmergencyNotice } from "@/components/EmergencyNotice";
import { IndependenceStrip } from "@/components/IndependenceStrip";
import { CONTACT, LOCATIONS } from "@/data/site";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("contact.seoTitle")} description={t("contact.metaDescription")} path="/contact" exact />
      <PageHero
        eyebrow={t("contact.eyebrow")}
        title={t("contact.h1")}
        subtitle={t("contact.subtitle")}
        crumbs={[{ label: t("nav.home"), to: "/" }, { label: t("nav.contact") }]}
      />

      <section className="vc-container py-14 sm:py-16">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <Reveal>
              <h2 className="text-2xl font-extrabold text-[hsl(var(--vc-ink))]">{t("contact.talkTitle")}</h2>
              <p className="mt-2 text-sm leading-relaxed text-[hsl(var(--vc-slate))]">{t("contact.talkText")}</p>
              <ContactChannels className="mt-6" />
            </Reveal>

            <Reveal className="mt-6" delay={0.05}>
              <div className="rounded-2xl border border-[hsl(var(--vc-line))] bg-white p-6 vc-shadow-soft">
                <ul className="space-y-3 text-sm">
                  <li className="flex items-center gap-3 text-[hsl(var(--vc-ink))]"><Clock className="h-4 w-4 text-brand" /> {t("footer.whatsapp247")}</li>
                  <li className="flex items-start gap-3 text-[hsl(var(--vc-ink))]"><Languages className="mt-0.5 h-4 w-4 shrink-0 text-brand" /> {CONTACT.languages.join(", ")}</li>
                  <li className="flex items-start gap-3 text-[hsl(var(--vc-ink))]"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" /> {LOCATIONS.map((l) => l.name).join(", ")}</li>
                </ul>
              </div>
            </Reveal>

            <Reveal className="mt-6" delay={0.1}><EmergencyNotice /></Reveal>
            <Reveal className="mt-6" delay={0.12}><IndependenceStrip /></Reveal>
          </div>

          <Reveal delay={0.05}>
            <div className="rounded-2xl border border-[hsl(var(--vc-line))] bg-white p-6 vc-shadow-card sm:p-8">
              <h2 className="text-2xl font-extrabold text-[hsl(var(--vc-ink))]">{t("contact.formTitle")}</h2>
              <p className="mt-1.5 text-sm text-[hsl(var(--vc-slate))]">{t("contact.formText")}</p>
              <div className="mt-6"><ContactForm defaultType="general" source="contact-page" /></div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Contact;
